@if (type() && type() !== 'dataset' && slug()) {
  <content-selector2 [slug]="slug()" [options]="options"></content-selector2>
}
